import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PartyPlaceMergeModel } from 'app/generated/backend/yard/api/party-place-merge-model';

@Injectable()
export class PartyPlaceMergeHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	get(
		partyId: number,
		id: number
	): Observable<JsonResourceResponse<PartyPlaceMergeModel>> {
		return this.http.get<JsonResourceResponse<PartyPlaceMergeModel>>(`api/v1/yard/parties/${partyId}/places/${id}/merge`).pipe(
			map(response => response),
			catchError(this.handleError));
	}
	put(
		partyId: number,
		id: number,
		request: PartyPlaceMergeModel
	): Observable<JsonResourceResponse<PartyPlaceMergeModel>> {
		return this.http.put<JsonResourceResponse<PartyPlaceMergeModel>>(`api/v1/yard/parties/${partyId}/places/${id}/merge`, request).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		PartyPlaceMergeHandlerService
	]
})
export class PartyPlaceMergeHandlerModule { }
